"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const check_1 = require("../common/check");
/**
 * A line segment or curve segment used as input to a CreaseBuilder object.
 */
class CreaseBuilderSegment {
    /**
     * Constructs a CreaseBuilderSegment object.
     * @param {Bezier2} points An array of two, three, or four 2D points defining a line segment,
     * quadratic Bezier segment, or cubic Bezier segment.
     * @param {CreaseEdgeAssignment} assignment The assignment of this segment.
     * @param {number | null} foldAngle The fold angle of this segment, or null.
     */
    constructor(points, assignment, foldAngle = null) {
        // Check inputs.
        check_1.check.isArray('points', points, [2, 4], check_1.check.is2DPoint);
        check_1.check.isAmong('assignment', assignment, ['U', 'C', 'B', 'M', 'V', 'F', null]);
        if (foldAngle !== null) {
            if (assignment === 'F' && foldAngle !== 0) {
                throw new Error('Edges of type F must have 0 fold angle.');
            }
            else if (assignment === 'C' || assignment === 'B') {
                throw new Error('Edges of type C or B must have null fold angle.');
            }
            else {
                check_1.check.isInRange('foldAngle', foldAngle, 0, 180);
            }
        }
        this._points = points;
        this._assignment = assignment;
        this._foldAngle = foldAngle;
    }
    /**
     * Returns the points of this segment.
     * @returns {Bezier2} The points of this segment.
     */
    get points() {
        return this._points;
    }
    /**
     * Returns the assignment of this segment.
     * @returns {CreaseEdgeAssignment} The assignment of this segment.
     */
    get assignment() {
        return this._assignment;
    }
    /**
     * Returns the fold angle of this segment.
     * @returns {number | null} The fold angle of this segment.
     */
    get foldAngle() {
        return this._foldAngle;
    }
}
exports.CreaseBuilderSegment = CreaseBuilderSegment;
//# sourceMappingURL=CreaseBuilderSegment.js.map